import axios from "@/axios.js";
import Grades from "./grades_service";

export default {
  getAllGrades({ commit }, item) {
    return new Promise((resolve, reject) => {
      Grades.getAllGrades(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  getAllGradeSteps({ commit }, item) {
    return new Promise((resolve, reject) => {
      Grades.getAllGradeSteps(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  fetchGrades(context, gradeId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/grades/grades/${gradeId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchGradeStep(context, gradeId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/grades/grades/grade_step/${gradeId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllGradesByCampaignId(context, campaignId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/grades/grades/grades_by_campaign_id/${campaignId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllGradesByCanBeChangedBySD(context, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/grades/grades/get_all_grades_can_be_changed_by_sd", {
          item: item
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeGrade(context, gradeId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/grades/grades/${gradeId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeGradeStep(context, gradeId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/grades/grades/grade_step/${gradeId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getExistingGradeLists(context, grade_from) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/grades/grades/get_existing_grade_lists/${grade_from}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  searchExistingGradeLists(context, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/grades/grades/search_existing_grade_lists", {
          item: item
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateGrades({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/grades/grades/update_grade", {
          item: item
        })
        .then(response => {
        
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addGrades({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/grades/grades/add_grades", {
          item: item
        })
        .then(response => {
          // // console.log(response)
          commit(
            "ADD_ITEM",
            Object.assign(item, {
              id: response.data.id
            })
          );
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeGrades({ commit }, gradeId) {
    return new Promise((resolve, reject) => {
      // alert(roleId)
      axios
        .delete(`/api/grades/grades/${gradeId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addGradeSteps({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/grades/grades/add_grade_steps", {
          item: item
        })
        .then(response => {
          // // console.log(response)
          commit(
            "ADD_ITEM",
            Object.assign(item, {
              id: response.data.id
            })
          );
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateGradeSteps({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/grades/grades/update_grade_steps", {
          item: item
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  cloneGrade({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/grades/grades/clone_grade", {
          item: item
        })
        .then(response => {         
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
